import { render, staticRenderFns } from "./pc_award.vue?vue&type=template&id=3582ef02&scoped=true"
import script from "./pc_award.vue?vue&type=script&lang=js"
export * from "./pc_award.vue?vue&type=script&lang=js"
import style0 from "./pc_award.vue?vue&type=style&index=0&id=3582ef02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582ef02",
  null
  
)

export default component.exports